import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/pos.png";
import "../style/navbar.css"
import { Offcanvas } from "bootstrap";

function Sidebar() {

  const location = useLocation();
  const navigate = useNavigate();

  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}"); 


  const closeSidebar = () => {
  const el = document.getElementById("sidebarMenu");
  const bs = Offcanvas.getInstance(el);

  if (bs) {
    bs.hide();
  }

  // ✅ REMOVE BACKDROP (blur fix)
  const backdrop = document.querySelector(".offcanvas-backdrop");
  if (backdrop) {
    backdrop.remove();
  }

  // ✅ RESTORE BODY SCROLL
  document.body.classList.remove("offcanvas-backdrop", "modal-open");
  document.body.style.overflow = "auto";
};


const department = empDetails?.department?.toLowerCase();
const branch = empDetails?.branchname?.toLowerCase();

// Hide conditions
const hideRequest = department === "sales" || department === "s-manager" || branch !=="corporate" ;

const hideMyPerformance =
  department === "s-manager" || branch === "corporate" || department === "it" ;

const hideIncentive =
  department === "s-manager" || branch === "corporate" || department === "it" ;


  
  return (
    <div
      className="offcanvas offcanvas-start"
      tabIndex="-1"
      id="sidebarMenu"
      style={{ width: "260px", background: "#2B7CD3" }}
    >
      {/* HEADER */}
      {/* <div className="offcanvas-header">
        <img src={logo} alt="logo" style={{ height: "50px" }} />
        <button
          type="button"
          className="btn-close btn-close-white"
          data-bs-dismiss="offcanvas"
        ></button>
      </div> */}

      {/* BODY */}
      <div className="offcanvas-body p-0">
        <ul className="list-unstyled fw-bold text-white">

          
          <li className={`li ${location.pathname === "/dashboard/attendance" ? "active-menu" : ""}`} onClick={() => {
                    navigate("/dashboard/attendance");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/attendance" className="text-white text-decoration-none"  onClick={closeSidebar}> */}
              {/* <i className="bi bi-pencil-square me-2"></i> */}
              <i className="fa-solid fa-clipboard-user me-2"></i>
              Attendance
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/leave" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/leave");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/leave" className="text-white text-decoration-none"  onClick={closeSidebar}> */}
              {/* <i className="bi bi-pen me-2"></i> */}
              <i className="fa-solid fa-calendar me-2"></i>
              Leave
              {/* </Link> */}
          </li>

           {!hideMyPerformance && (
              <li
                className={`li ${
                  location.pathname === "/dashboard/myperform"
                    ? "active-menu"
                    : ""
                }`}
                onClick={() => {
                  navigate("/dashboard/myperform");
                  closeSidebar();
                }}
                style={{ cursor: "pointer" }}
              >
                <i class="fa-solid fa-chart-bar me-2"></i>
                My Performance
              </li>
            )}

           {/*  {!hideIncentive && (
              <li
                className={`li ${
                  location.pathname === "/dashboard/incentive"
                    ? "active-menu"
                    : ""
                }`}
                onClick={() => {
                  navigate("/dashboard/incentive");
                  closeSidebar();
                }}
                style={{ cursor: "pointer" }}
              >
                <i class="fa-solid fa-circle-dollar-to-slot me-2"></i>
                Incentive
              </li>
            )} 
               */}


          <li className={`li ${location.pathname === "/dashboard/management" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/management");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/management" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-cash-coin me-2"></i> */}
              <i className="bi bi-kanban me-2"></i>
              Management Desk
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/offers" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/offers");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/offers" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-wallet2 me-2"></i> */}
              <i className="fa-solid fa-percent me-2"></i>
              Offers
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/careers" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/careers");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/carrers" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-wallet2 me-2"></i> */}
              <i className="fa-solid fa-briefcase me-2"></i>
              Carrers
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/birthday" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/birthday");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/birthday" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-wallet2 me-2"></i> */}
              <i className="fa-solid fa-cake-candles me-2"></i>
                Birthdays
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/awards" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/awards");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/awards" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-wallet2 me-2"></i> */}
              <i className="fa-solid fa-award me-2"></i>
                Awards
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/contacts" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/contacts");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/contacts" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-wallet2 me-2"></i> */}
              <i className="fa-solid fa-address-book me-2"></i>
                Contacts
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/Payslip" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/Payslip");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/Payslip" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-wallet2 me-2"></i> */}
              <i className="fa-solid fa-sheet-plastic me-2"></i>
                Payslip
            {/* </Link> */}
          </li>

          {!hideRequest && (
            <li
              className={`li ${
                location.pathname === "/dashboard/request"
                  ? "active-menu"
                  : ""
              }`}
              onClick={() => {
                navigate("/dashboard/request");
                closeSidebar();
              }}
              style={{ cursor: "pointer" }}
            >
              <i className="fa-solid fa-check me-2"></i>
              Request
            </li>
          )}

          <li className={`li ${location.pathname === "/dashboard/feedback" ? "active-menu" : ""}`}  onClick={() => {
                    navigate("/dashboard/feedback");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/feedback" className="text-white text-decoration-none" onClick={closeSidebar}> */}
              {/* <i className="bi bi-wallet2 me-2"></i> */}
              <i className="fa-solid fa-comment me-2"></i>
                Feedback
            {/* </Link> */}
          </li>

          <li className={`li ${location.pathname === "/dashboard/about" ? "active-menu" : ""}`} onClick={() => {
                    navigate("/dashboard/about");
                    closeSidebar();
                  }}
                  style={{ cursor: "pointer" }}>
            {/* <Link to="/dashboard/attendance" className="text-white text-decoration-none"  onClick={closeSidebar}> */}
              {/* <i className="bi bi-pencil-square me-2"></i> */}
              <i className="fa-solid fa-circle-info me-2"></i>
              About Us
            {/* </Link> */}
          </li>



        </ul>
      </div>
    </div>
  );
}

export default Sidebar;